import { render, staticRenderFns } from "./shebeiTask.vue?vue&type=template&id=28955f4c&scoped=true&"
import script from "./shebeiTask.vue?vue&type=script&lang=js&"
export * from "./shebeiTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28955f4c",
  null
  
)

export default component.exports